export class MountingType {
	public static NONE: number = 0;
	public static CRISS_CROSS: number = 1;
	public static DIRECT: number = 2;
}
